import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPromotions = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M39.63 22.87 17.13.37a1.24 1.24 0 0 0-.88-.36L1.25 0C.58 0 .02.56.02 1.25l-.01 15c0 .33.13.65.37.89l22.5 22.5c.49.48 1.28.48 1.77 0l15-15c.48-.49.48-1.28 0-1.77zM23.75 36.98 2.5 15.74V2.5h13.23l21.25 21.26-13.23 13.22z" }), /* @__PURE__ */ _jsx("path", { d: "M13.42 22.58c.56.56 1.46.56 2.02 0l7.14-7.14a1.43 1.43 0 1 0-2.02-2.02l-7.14 7.14a1.43 1.43 0 0 0 0 2.02zm4 4c.56.56 1.46.56 2.02 0l7.14-7.14a1.43 1.43 0 1 0-2.02-2.02l-7.14 7.14a1.43 1.43 0 0 0 0 2.02zM7.87 7.85a3.07 3.07 0 0 0 0 4.28 3 3 0 0 0 4.26-.03 3.03 3.03 0 0 0 0-4.25 3.1 3.1 0 0 0-4.26 0z" })]
});
export default SvgPromotions;
